export default __webpack_public_path__ + "static/media/dry_cool_large.ac95d43e.jpg";